module.exports = __webpack_public_path__ + "static/img/leumi-large.2ba25ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/leumi-large.svg
// module id = VD+d
// module chunks = 6